
import React, { useState, } from 'react';
import { Button, Divider } from '@alifd/next';

import './App.css';
import './Terms.css';

import ApplicationConfig from './constant.jsx';

import qrcode from './asset/img_qr_ios.png'
import sample1 from './asset/img_sample_1.png'
import sample2 from './asset/img_sample_2.png'
import sample3 from './asset/img_sample_3.png'
import sample4 from './asset/img_sample_4.png'
import rectangle from './asset/img_title_block.png'
import top from './asset/img_top_script.png'
import logo from './asset/img_logo.png'

const Image: React.FC = (props) => {
  return <img {...props} src={`${props.source}`} />;
}

const MainView: React.FC = () => {
  return (
    <div className="main">
      <div data-v-48282f5d="" data-v-7a87c078="" class="home">
        <div data-v-48282f5d="" class="home-top">
          <Image data-v-48282f5d="" source={logo} style={{width: '200px'}} />
          <div data-v-48282f5d="" class="home-top-content">
              <Image data-v-48282f5d="" source={top} style={{width: '60%'}} />
            {/* <p data-v-48282f5d="" id="subtitle">3000 + 热门精彩模板 轻松上手</p> */}
            <div data-v-48282f5d="" class="sdk-box">
              <div data-v-48282f5d="" class="sdk-box-inner">
                <Image data-v-48282f5d="" source={"https://huantuai.com/img//77787db34268415bacabfe99b545fca6.png"} class="btn-logo" style={{width: '20px', height: '20px'}} />
                  <span data-v-48282f5d="">IOS下载</span>
                <div data-v-48282f5d="" class="code-box">
                  <div data-v-48282f5d="" id="qrcode" title="https://apps.apple.com/cn/app/%E9%85%B7%E6%8B%8D-%E6%8B%A5%E6%8A%B1%E8%A7%86%E9%A2%91-%E5%86%99%E7%9C%9F/id1629049390"><canvas width="85" height="85" style={{display: 'none'}}></canvas>
                    <Image alt="Scan me!" style={{display: 'block'}} source={qrcode} />
                  </div>
                  <div data-v-48282f5d="">请用手机扫码</div>
                </div>
              </div>
              {/* <div data-v-48282f5d="" class="sdk-box-inner">
                <Image data-v-48282f5d="" source={"https://huantuai.com/img//b30d2845a29044b582dee24a7845f3d6.png"} class="btn-logo" /><span data-v-48282f5d="">安卓下载</span>
                <div data-v-48282f5d="" class="code-box">
                  <div data-v-48282f5d="" id="qrcode-android" title="https://www.pgyer.com/WbX7QyAA">
                    <canvas width="85" height="85" style={{display: 'none'}}></canvas>
                    <Image alt="Scan me!" style={{display: 'block'}} source={"data:image/png;base64,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"} />
                  </div>
                  <div data-v-48282f5d="">请用手机扫码</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div data-v-48282f5d="" class="home-sample left start">
          <div data-v-48282f5d="" class="show">
            <Image data-v-48282f5d="" id="sample" source={sample1} class="sample" />
          </div>
          <div data-v-48282f5d="" class="description">
            <Image data-v-48282f5d="" source={rectangle} class="icon" />
            <h3 data-v-48282f5d="">{ApplicationConfig.sample1}</h3>
            <p data-v-48282f5d="">{ApplicationConfig.sampleDesc1}</p>
          </div>
        </div>
        <div data-v-48282f5d="" class="home-sample right">
          <div data-v-48282f5d="" class="description">
            <Image data-v-48282f5d="" source={rectangle} class="icon" />
            <h3 data-v-48282f5d="">{ApplicationConfig.sample2}</h3>
            <p data-v-48282f5d="">{ApplicationConfig.sampleDesc2}</p>
          </div>
          <div data-v-48282f5d="" class="show">
            <Image data-v-48282f5d="" id="sample" source={sample2} alt="sample" />
            {/* <Image data-v-48282f5d="" id="action" source={sample2} alt="action" /> */}
          </div>
        </div>
        <div data-v-48282f5d="" class="home-sample left">
          <div data-v-48282f5d="" class="show">
            <Image data-v-48282f5d="" id="sample" source={sample3} alt="sample" />
            {/* <Image data-v-48282f5d="" id="action" source={""} alt="action" /> */}
          </div>
          <div data-v-48282f5d="" class="description">
            <Image data-v-48282f5d="" source={rectangle} class="icon" />
            <h3 data-v-48282f5d="">{ApplicationConfig.sample3}</h3>
            <p data-v-48282f5d="">{ApplicationConfig.sampleDesc3}</p>
          </div>
        </div>
        <div data-v-48282f5d="" class="home-sample right end">
          <div data-v-48282f5d="" class="description">
            <Image data-v-48282f5d="" source={rectangle} class="icon" />
            <h3 data-v-48282f5d="">{ApplicationConfig.sample4}</h3>
            <p data-v-48282f5d="">{ApplicationConfig.sampleDesc4}</p>
          </div>
          <div data-v-48282f5d="" class="show">
            <Image data-v-48282f5d="" id="sample" source={sample4} alt="sample" />
            {/* <Image data-v-48282f5d="" id="action" source={""} alt="action" /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainView;